import * as React from "react";

function SvgIcons8Lowercase(props, ref) {
  return (
    <svg viewBox="0 0 32 32" width="1em" height="1em" {...{ ...props, ref }}>
      <path d="M15 6v2h6v18h2V8h6V6zM3 12v2h4v12h2V14h4v-2z" />
    </svg>
  );
}

export default React.forwardRef(SvgIcons8Lowercase);
